import { WelcomeSection, QuickActions, InstagramOverview, CompetitorWatchlistSection } from '@/components/home'
import { useAuth } from '@/auth'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { Separator } from '@/components/ui/separator'

export function HomePage() {
  const { isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="space-y-10">
        {/* Welcome Section Skeleton */}
        <div className="space-y-4">
          <Skeleton className="h-8 w-[300px]" />
          <Skeleton className="h-4 w-[400px]" />
          <Separator />
        </div>

        {/* Quick Actions Skeleton */}
        <div className="grid gap-4 md:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <Card key={i}>
              <CardHeader className="pb-4">
                <div className="flex items-center gap-3">
                  <Skeleton className="h-8 w-8 rounded-lg" />
                  <Skeleton className="h-5 w-[120px]" />
                </div>
              </CardHeader>
              <CardContent>
                <Skeleton className="h-3 w-full mb-2" />
                <Skeleton className="h-3 w-3/4" />
              </CardContent>
            </Card>
          ))}
        </div>


      </div>
    )
  }

  return (
    <div className="space-y-10">
      <WelcomeSection />
      <div className="space-y-4">
        <h2 className="text-lg font-semibold tracking-tight">Instagram Overview</h2>
        <InstagramOverview />
      </div>
      <div className="space-y-4">
        <h2 className="text-lg font-semibold tracking-tight">Competitor Watchlist</h2>
        <CompetitorWatchlistSection />
      </div>
      <QuickActions />
    </div>
  )
}